import React from 'react';
import { Helmet } from "react-helmet";
 
class MetaTags extends React.Component {
  render() {
    return (
      <Helmet>
        <title>Get a local mercedes bumper repair estimate online.</title>
        <meta name="description" content="Our mobile Mercedes Benz auto body shop comes to you. Free estimates for mercedes front and rear bumper replacement & bumper repair cost" />
        <meta itemprop="name" content="Get a local mercedes bumper repair estimate online."/>
        <meta itemprop="description" content="Our mobile Mercedes Benz auto body shop comes to you. Free estimates for mercedes front and rear bumper replacement & bumper repair cost"/>
        <meta itemprop="image" content="https://www.fyxme.com/images/b1-low.jpg" />

        <meta property="og:url" content="https://www.fyxme.com" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Get a local mercedes bumper repair estimate online." />
        <meta property="og:description" content="Our mobile Mercedes Benz auto body shop comes to you. Free estimates for mercedes front and rear bumper replacement & bumper repair cost" />
        <meta property="og:image" content="https://www.fyxme.com/images/b1-low.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Get a local mercedes bumper repair estimate online." />
        <meta name="twitter:description" content="Our mobile Mercedes Benz auto body shop comes to you. Free estimates for mercedes front and rear bumper replacement & bumper repair cost" />
        <meta name="twitter:image" content="https://www.fyxme.com/images/b1-low.jpg" />
      </Helmet>
      )
  }
}

export default MetaTags;